import React from 'react'

import enhance from './enhance'
import { ChangeLabel, Change, ChangeFrom, ChangeTo } from './styles'
import { getTestId } from '../utils'

const Component = ({ name, benefit = {}, label }) => (
  <li data-testid={getTestId(name)}>
    <ChangeLabel>{label}</ChangeLabel>
    <Change>
      <ChangeFrom data-testid="current">{benefit.current}</ChangeFrom>
      <div>to</div>
      <ChangeTo data-testid="pending">{benefit.pending}</ChangeTo>
    </Change>
  </li>
)

Component.displayName = 'ChangeDelta'

export default enhance(Component)
